export function APIURL(params) {
  let Url = '';
  let paralUrl = '';
  if (process.env.NODE_ENV === 'development') {
   Url = 'http://localhost:8000';
    //Url = 'https://inventory.jojohotpot.com:8080';
  } else if (process.env.NODE_ENV === 'production') {
    Url = 'https://inventory.jojohotpot.com:8000';
  } else {
    Url = '';
  }
  if (params && params !== undefined && params !== '/' && params !== '/') {
    paralUrl = params;
  }
  return Url + paralUrl;
}

export function ImageURL(params) {
  let Url = '';
  let paralUrl = '';
  if (process.env.NODE_ENV === 'development') {
    Url = 'http://localhost:8000';
  } else if (process.env.NODE_ENV === 'production') {
    Url = 'https://inventory.jojohotpot.com:8000';
  } else {
    Url = '';
  }

  if (!params) {
    return;
  }
  if (params.includes('://')) {
    return params;
  }
  if (params && params !== undefined && params !== '/' && params !== '/') {
    paralUrl = params;
  }
  return Url + '/' + paralUrl;
}

export const IDLE_TIMEOUT = 1000 * 60 * 10; //10 min
